const fg_broadcast = {
    dispatch: function(data) {
        switch (data.action) {
            case 'increment':
                var selector = data.selector;
                fg_broadcast.increment(selector);
                break;
            case 'popup':
                var url = data.url;
                fg_broadcast.popup(url);
                break;
            case 'toast':
                var message = data.message;
                fg_broadcast.toast(message);
                break;
            case 'openModalUrl':
                var url = data.url;
                fg_broadcast.openModalUrl(url);
                break;
            case 'openUrl':
                var url = data.url;
                fg_broadcast.openUrl(url);
                break;
            case 'run':
                var js = data.js;
                fg_broadcast.run(js);
                break;
            case 'loadScript':
                var url = data.url;
                var callback = data.callback;
                fg_broadcast.loadScript(url, callback);
                break;
            case 'redirect':
                var url = data.url;
                fg_broadcast.redirect(url);
                break;
            case 'getContext':
                fg_broadcast.getContext();
                break;
        }
    },
    increment: function(sel) {
        console.log('increment');
        var count = parseInt($(sel).html());
        $(sel).html(count + 1);
    },
    popup: function(url) {
        console.log('popup', url);
        viewModal(url);
    },
    toast: function(message) {
        console.log('toast', message);
        growl(message);
    },
    openModalUrl: function(url) {
        console.log('openModalUrl', url);
        viewModal(url);
    },
    openUrl: function(url) {
        console.log('openurl', url);
        window.open(url, 'admin_window');
    },
    run: function(js) {
        console.log('run', js);
    },
    loadScript: function(url, callback) {
        console.log('loadScript', url, callback);
        $.getScript(url, callback);
    },
    redirect: function(url) {
        console.log('redirect', url);
        window.location.href = url;
    },
    getContext: function() {
        console.log('getContext');
    },
    test: function() {
        console.log('test');
    }
};

module.exports = fg_broadcast;
